import { formatTime } from '@/utils/date';
import { arrify } from '@/utils/utils';
import { getOffices, getDepts } from './offices';
import materials from './materials';
import Mock from 'mockjs';

let offices = null;
let depts = null;

const initOffice = () => {
  if (offices && depts) return;
  offices = getOffices();
  depts = getDepts(offices);
};

// const Random = Mock.Random;

export const getAlarmList = () => {
  return Mock.mock({
    'dataList|3': [
      {
        '_alarmCount|1-20': 15,
        '_alarmType|+1': ['_bioFactor', '_contraband', '_prohibitedAndDangerous']
      }
    ],
    dimensions: ['_alarmType', '_alarmCount']
  });
};

export const getDetectionList = () => {
  return Mock.mock({
    'dataList|5': [
      {
        '_checkCount|5-40': 15,
        '_materialName|+1': materials
      }
    ],
    dimensions: ['_materialName', '_checkCount']
  });
};

export const getAlarmCount = alarmList => {
  return getCount(alarmList, '_alarmCount');
};

export const getDetectionCount = detectionList => {
  return getCount(detectionList, '_checkCount');
};

export const getYearAlarm = () => {
  return Mock.mock({
    'dataList|7': [
      {
        '_alarmCount|1-900': 2,
        '_alarmType|+1': [
          '_nuclear',
          '_chemicalGas',
          '_bioFactor',
          '_contraband',
          '_prohibitedAndDangerous',
          '_smoke',
          '_toxicGas'
        ]
      }
    ],
    dimensions: ['_alarmType', '_alarmCount']
  });
};

export const getYearDetection = () => {
  initOffice();
  return Mock.mock({
    'dataList|5': [
      {
        '_checkCount|100-1600': 2,
        '_deptName|+1': depts
      }
    ],
    dimensions: ['_deptName', '_checkCount']
  });
};

const getMonths = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  return Array(month)
    .fill(0)
    .map((_, i) => {
      return `${year}-${i + 1}`;
    });
};

function makeYearAlarmTrend(months) {
  const res = Mock.mock({
    [`dataList|${months.length}`]: [
      {
        '_alarmCount|1-900': 10,
        '_monthly|+1': months
      }
    ],
    dimensions: ['_monthly', '_alarmCount']
  });

  return {
    dataList: arrify(res.dataList),
    dimensions: res.dimensions
  };
}

function makeYearDetectionTrend(months) {
  const res = Mock.mock({
    [`dataList|${months.length}`]: [
      {
        '_checkCount|100-1600': 10,
        '_monthly|+1': months
      }
    ],
    dimensions: ['_monthly', '_checkCount']
  });

  return {
    dataList: arrify(res.dataList),
    dimensions: res.dimensions
  };
}

export const getYearDetectionTrend = () => makeYearDetectionTrend(getMonths());
export const getYearAlarmTrend = () => makeYearAlarmTrend(getMonths());

/**
 * 生成表格数据
 * @param {number} count
 * @param {{begin:number, timeAutoIncrement: number}} param1
 * @returns {any[]}
 */
export function makeTableData(count, { begin = Date.now(), timeAutoIncrement = 1 }) {
  initOffice();
  const res = Mock.mock({
    [`data|${count || 1}`]: [
      {
        [`checkTime|+${timeAutoIncrement}`]: begin,
        'result|1': materials,
        'device|1': offices
      }
    ]
  });

  return transformTableData(arrify(res.data));
}

export function transformTableData(data) {
  return data.map(e => ({
    checkTime: formatTime(e.checkTime),
    sn: e.device.id,
    dept: e.device.dept,
    result: e.result
  }));
}

function getCount(data, key) {
  return data.dataList.reduce((pre, e) => pre + e[key], 0);
}
